import React, { useEffect, useRef, useState } from 'react';
import { ScrollView, View, Text } from 'react-native';
import i18n from 'i18n-js';
import LinearGradient from 'react-native-linear-gradient';
import { connect } from 'react-redux';

import Editor from '@components/operatorPanel/components/OperatorPanelInformation/components/OperatorPanelInformationNotesScreen/Editor';
import ColorWrapper from '@styles/colors';

import { scaleOP } from '@components/frame';

import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { ColorFunction } from '@styles/colors/types';
import { fontOP } from '@styles/fonts';
import { generateImageURL } from '@reducers/blobStorage';
import { ODataDocument } from '@v2/components/imageHandling/domain/types';

interface NoteContentPreviewProps {
  note: ODataDocument;
  scale?: ScaleFunction;
  font?: typeof fontOP;
  C: ColorFunction;
  // todo
  generateImageURL: any;
}

const NoteContentPreview: React.FC<NoteContentPreviewProps> = ({ C, note, scale = scaleOP, font = fontOP, generateImageURL }) => {
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const [scrollViewHeight, setScrollViewHeight] = useState<number>(0);
  const [contentHeight, setContentHeight] = useState<number>(0);
  const [textContent, setTextContent] = useState<string>('');

  useEffect(() => {
    setIsOverflowing(contentHeight > scrollViewHeight);
  }, [contentHeight, scrollViewHeight]);

  useEffect(() => {
    if (!note || note?.extensionOriginal === 'rtf') {
      setTextContent('');
      return;
    }

    (async () => {
      const url = await generateImageURL({ item: { ...note, imageHash: note.contentHash }, download: true });
      const response = await fetch(url, { ignoreInterceptor: 'true' });
      const fileContent = await response.text();

      setTextContent(fileContent);
    })();
  }, [note]);

  return (
    <View
      style={{
        position: 'relative',
        maxHeight: scale(360),
      }}
    >
      <ScrollView
        style={{
          maxHeight: '100%',
        }}
        onLayout={(event) => {
          const { height } = event.nativeEvent.layout;
          setScrollViewHeight(height);
        }}
        onContentSizeChange={(_, contentHeight) => {
          setContentHeight(contentHeight);
        }}
      >
        {note?.extensionOriginal === 'rtf' ? (
          <Editor previewNote={note} rawContent={note.rawContent} setTouched={() => {}} readOnly onChange={() => {}} />
        ) : (
          <Text style={[]}>{textContent}</Text>
        )}
      </ScrollView>
      {isOverflowing ? (
        <>
          <View
            style={{
              position: 'absolute',
              bottom: scale(18),
              left: '50%',
              transform: 'translateX(-25%)',
              backgroundColor: C('Gray/Light/4'),
              paddingHorizontal: scale(13),
              paddingBlock: scale(6.5),
              borderRadius: scale(14.5),
            }}
          >
            <Text
              style={[
                font['Button 2'],
                {
                  color: C('Button/Light/Tertiary Text'),
                  textAlign: 'center',
                  fontWeight: 500,
                },
              ]}
            >
              {i18n.t('View More')}
            </Text>
          </View>
          <LinearGradient
            colors={['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 0.9)', 'rgba(255, 255, 255, 1)']}
            locations={[0, 0.8756, 1]}
            angle={180}
            useAngle={true}
            style={{
              height: scale(67),
              width: '100%',
              position: 'absolute',
              bottom: 0,
            }}
          />
        </>
      ) : null}
    </View>
  );
};

export default connect(() => ({}), { generateImageURL })(ColorWrapper(NoteContentPreview));
